import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAppBar,{staticClass:"navbarStyling",attrs:{"app":"","flat":""}},[_c('ContactForm',{ref:"OpenContactForm"}),_c('a',{attrs:{"href":"/"}},[(_vm.$vuetify.breakpoint.mdAndDown)?_c(VImg,{staticClass:"mt-5 mb-5",attrs:{"src":"img/digitup-logo.jpg","max-height":"150px","max-width":"150px","contain":""}}):_c(VImg,{staticClass:"mt-15",attrs:{"src":"img/digitup-logo.jpg","max-height":"130px","max-width":"150px","contain":""}})],1),_c(VSpacer),_c('div',{staticClass:"mt-10"}),_c(VSpacer)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }